import { APP_BRAND_ID } from "@/lib/branding";

/**
 * Nomes antigos que o browser desta instalação pode ainda ter guardados.
 *
 * Até 2026-09-01 as chaves do `localStorage` e a base IndexedDB da fila da portaria levavam o nome de um cliente
 * escrito no código — e por isso em todas as builds. Mudaram para nomes neutros, mas quem já tinha dados guardados
 * (um layout de dashboard, registos da portaria por enviar) não os pode perder.
 *
 * Em vez de repetir aqui o nome desse cliente, o nome antigo deriva-se da marca da própria build: na instalação desse
 * cliente dá exatamente o nome antigo; nas outras nunca existiu nada com ele e a procura não faz nada. Assim o nome
 * de um cliente não volta ao código, e o comportamento de quem tem dados antigos fica igual.
 *
 * `marca` é parâmetro só para os testes poderem passar outra.
 */

/** Chaves que são nossas hoje: nunca se tratam como «antigas», mesmo que a marca as faça coincidir. */
const CHAVES_ATUAIS = new Set(["auth_token", "access_token", "refresh_token"]);

/** Chaves de token do `localStorage` com o nome antigo (`<marca>_token`). */
export function legacyTokenKeys(marca: string = APP_BRAND_ID): string[] {
  const chave = `${marca}_token`;
  return marca && !CHAVES_ATUAIS.has(chave) ? [chave] : [];
}

/** A chave de layout antiga que corresponde a `aihumanerp.<resto>`, ou `null` se não há nada a migrar. */
export function legacyLayoutKey(storageKey: string, marca: string = APP_BRAND_ID): string | null {
  if (!marca || !storageKey.startsWith("aihumanerp.")) return null;
  const antiga = `${marca}.${storageKey.slice("aihumanerp.".length)}`;
  return antiga === storageKey ? null : antiga;
}

/** O nome antigo da base IndexedDB da fila da portaria (`<marca>-security`), ou `null` se for o mesmo que o atual. */
export function legacySecurityDbName(atual: string, marca: string = APP_BRAND_ID): string | null {
  const antigo = `${marca}-security`;
  return marca && antigo !== atual ? antigo : null;
}
